import { useEffect, useRef, useState } from 'react';
import { GameClient } from '../game/GameClient.js';
import type { GameClientOptions } from '../game/GameClient.js';

/** Mounts a GameClient against a container div. Returns the container ref (attach
 * to a div) and the live client once initialised. Re-creates on option change. */
export const useGameClient = (
  options: GameClientOptions,
): { containerRef: React.RefObject<HTMLDivElement | null>; client: GameClient | null } => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [client, setClient] = useState<GameClient | null>(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const gc = new GameClient(options);
    let disposed = false;
    void gc.init(el).then(() => {
      if (disposed) return;
      setClient(gc);
    });
    return (): void => {
      disposed = true;
      setClient(null);
      gc.destroy();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options.seed, options.mapWidth, options.mapHeight]);

  return { containerRef, client };
};
